import styled from "styled-components";

export const StyledCollaboratorExperience = styled.div<{
  $isComparison: boolean;
}>`
  & > div {
    justify-content: ${({ $isComparison }) =>
      $isComparison ? "space-between" : ""};
    display: flex;
    flex-direction: ${({ $isComparison }) =>
      $isComparison ? "row" : "column"};
    gap: 20px;
  }
`;
